import { API_ROOT } from '../../config/config'
import { doGet, doDownload, doPostFiles, doPost } from './utils'

// const API_ROOT = 'http://localhost:9016/api'

export const getBlacklistedById = (blacklistedId) => {
  const url = `${API_ROOT}/v1/audit/blacklisted/get/?id=${blacklistedId || ''}`
  return doGet(url)
}

export const saveBlacklisted = (request) => {
  const url = `${API_ROOT}/v1/audit/blacklisted/save`
  return doPostFiles(url, request)
}

export const editBlacklisted = (id) => {
  const url = `${API_ROOT}/v1/audit/blacklisted/save?id=${id}`
  return doPostFiles(url)
}

export const searchBlacklisted = (pageNum, pageSize, request) => {
  const url = `${API_ROOT}/v1/audit/blacklisted/list/search?pageNum=${pageNum || 0}&pageSize=${
    pageSize || 0
  }`
  return doPost(url, request)
}

export const callBlacklisted = (pageNum, pageSize) => {
  const url = `${API_ROOT}/v1/audit/blacklisted/list?pageNum=${pageNum || 0}&pageSize=${
    pageSize || 0
  }`
  return doGet(url)
}

export const downloadBlacklistAttacthment = (fileId) => {
  const url = `${API_ROOT}/v1/audit/blacklisted/attachments/download/${fileId}`
  return doDownload(url)
}

export const getRelateProject = (auditBlacklistedId, IdCard) => {
  const url = `${API_ROOT}/v1/audit/blacklisted/relate-project?auditBlacklistedId=${auditBlacklistedId}&IdCard=${IdCard}`
  return doGet(url)
}
